import { UserAgentApplication } from 'msal';
import { msalConfig} from '../config';
import { createRenderer } from 'react-dom/test-utils';


export const myMSALObj = new UserAgentApplication(msalConfig);
export const tenant = '0f9e35db-544f-4f60-bdcc-5ea416e6dc70';
// export const clientId = '2c15692f-8cfa-45b1-82d8-b36a4e91bf1d';
// export const clientSecret = 'DhZX.EOOlmApcdfGYB[a0/d1g9rswm2/';
// export const resource = 'https://projectbabylon.azure.net';
export const resource = 'https://purview.azure.net'
// export const requestOptions = {
//   method: 'POST',
//   headers: { 
//       'Content-Type': 'application/x-www-form-urlencoded',
//   },
//   body: new URLSearchParams({  
//     grant_type:'client_credentials',
//     client_id:clientId,
//     client_secret:clientSecret,
//     resource:resource
//   })
// };
export const emptySearchRequestOptions = {
  method: 'POST',
  headers:{
      'Authorization':'Bearer ' + sessionStorage.getItem('accessToken'),
      'Content-Type': 'application/json'
  },
  body: JSON.stringify({
      keywords:''
  })
};

export const searchRequestOptions = {
  method: 'POST',
  headers:{
      'Authorization':'Bearer ' + sessionStorage.getItem("accessToken"),
      'Content-Type': 'application/json'
  },
  body: JSON.stringify({
      keywords:sessionStorage.getItem("keyword")
  })
};
export const proxyUrl = "https://cors-anywhere.herokuapp.com/";
export const tokenUrl = 'https://login.windows.net/' + tenant +'/oauth2/token';

// export const detailsBaseUrl = 'https://sys-babylon.catalog.babylon.azure.com/api/atlas/v2/entity/guid/';
export const detailsBaseUrl = 'https://sys-purview.catalog.purview.azure.com/api/atlas/v2/entity/guid/';

export const entityList = [
  "ACABQ",
  "CAAC",
  "CEB Secretariat",
  "CTED",
  "DESA",
  "DGACM",
  "DGC",
  "DMSPC",
  "DOS",
  "DPO",
  "DPPA",
  "DSS",
  "ECA",
  "ECE",
  "ECLAC",
  "EOSG",
  "ESCAP",
  "ESCWA",
  "Ethics Office",
  "ICSC",
  "IIIM Syria",
  "JIU",
  "MICT",
  "MINUJUSTH",
  "MINURSO",
  "MINUSCA",
  "MINUSMA",
  "MONUSCO",
  "OAJ",
  "OCHA",
  "OCT",
  "ODA",
  "OHCHR",
  "OHRLLS",
  "OIOS",
  "OLA",
  "OOSA",
  "OSAA",
  "OSASG Cyprus",
  "OSASG-PG",
  "OSE Great Lakes",
  "OSE Haiti",
  "OSE Myanmar",
  "OSE Syria",
  "OSE Western Sahara",
  "OSE Yemen",
  "OSESG HoA",
  "OSESG-1559",
  "OSESG-B",
  "RCO Afghanistan",
  "RCO Albania",
  "RCO Algeria",
  "RCO Angola",
  "RCO Argentina",
  "RCO Armenia",
  "RCO Azerbaijan",
  "RCO Bahrain",
  "RCO Bangladesh",
  "RCO Barbados",
  "RCO Belarus",
  "RCO Belize",
  "RCO Benin",
  "RCO Bhutan",
  "RCO Bolivia",
  "RCO Bosnia & Herzegovina",
  "RCO Botswana",
  "RCO Brazil",
  "RCO Burkina Faso",
  "RCO Burundi",
  "RCO Cambodia",
  "RCO Cameroon",
  "RCO Cape Verde",
  "RCO Central African Republic",
  "RCO Chad",
  "RCO Chile",
  "RCO China",
  "RCO Colombia",
  "RCO Comoros",
  "RCO Costa Rica",
  "RCO Côte d'Ivoire",
  "RCO Cuba",
  "RCO Dem Republic of Congo",
  "RCO Djibouti",
  "RCO Dominican Republic",
  "RCO DPRK",
  "RCO Ecuador",
  "RCO Egypt",
  "RCO El Salvador",
  "RCO Equatorial Guinea",
  "RCO Eritrea",
  "RCO eSwatini",
  "RCO Ethiopia",
  "RCO Fiji",
  "RCO Gabon",
  "RCO Gambia",
  "RCO Georgia",
  "RCO Ghana",
  "RCO Guatemala",
  "RCO Guinea",
  "RCO Guinea-Bissau",
  "RCO Guyana",
  "RCO Haiti",
  "RCO Honduras",
  "RCO India",
  "RCO Indonesia",
  "RCO Iran",
  "RCO Iraq",
  "RCO Jamaica",
  "RCO Jordan",
  "RCO Kazakhstan",
  "RCO Kenya",
  "RCO Kosovo",
  "RCO Kuwait",
  "RCO Kyrgyzstan",
  "RCO Lao P.D.R",
  "RCO Lebanon",
  "RCO Lesotho",
  "RCO Liberia",
  "RCO Libya",
  "RCO Madagascar",
  "RCO Malawi",
  "RCO Malaysia",
  "RCO Maldives",
  "RCO Mali",
  "RCO Mauritania",
  "RCO Mauritius",
  "RCO Mexico",
  "RCO Moldova",
  "RCO Mongolia",
  "RCO Montenegro",
  "RCO Morocco",
  "RCO Myanmar",
  "RCO Namibia",
  "RCO Nepal",
  "RCO Niger",
  "RCO Nigeria",
  "RCO North Macedonia",
  "RCO Pakistan",
  "RCO Palestine",
  "RCO Panama",
  "RCO Papua New Guinea",
  "RCO Paraguay",
  "RCO Peru",
  "RCO Philippines",
  "RCO Republic of Congo",
  "RCO Rwanda",
  "RCO Samoa",
  "RCO São Tomé & Principe",
  "RCO Saudi Arabia",
  "RCO Senegal",
  "RCO Serbia",
  "RCO Sierra Leone",
  "RCO Somalia",
  "RCO South Africa",
  "RCO South Sudan",
  "RCO Sri Lanka",
  "RCO Sudan",
  "RCO Suriname",
  "RCO Syria",
  "RCO Tajikistan",
  "RCO Tanzania",
  "RCO Thailand",
  "RCO Timor-Leste",
  "RCO Togo",
  "RCO Trinidad & Tobago",
  "RCO Tunisia",
  "RCO Turkey",
  "RCO Turkmenistan",
  "RCO U.A Emirates",
  "RCO Uganda",
  "RCO Ukraine",
  "RCO Uruguay",
  "RCO Uzbekistan",
  "RCO Venezuela",
  "RCO Vietnam",
  "RCO Yemen",
  "RCO Zambia",
  "RCO Zimbabwe",
  "RSEA",
  "SVC",
  "UNAMA",
  "UNAMI",
  "UNAMID",
  "UNCTAD",
  "UNDCO",
  "UNDOF",
  "UNDRR",
  "UNEP",
  "UNFICYP",
  "UNGC",
  "UN-Habitat",
  "UNIDIR",
  "UNIFIL",
  "UNIOGBIS",
  "UNISFA",
  "UNITAD",
  "UNJSPF-CEO",
  "UNJSPF-RSG",
  "UNMHA",
  "UNMIK",
  "UNMISS",
  "UNMOGIP",
  "UNOAU",
  "UNOCA",
  "UNODC",
  "UNOG",
  "UNOMS",
  "UNON",
  "UNOP",
  "UNOV",
  "UNOWAS",
  "UNRCCA",
  "UNRGID",
  "UNRoD",
  "UNSCO",
  "UNSCOL",
  "UNSMIL",
  "UNSOM",
  "UNSOS",
  "UNTFHS",
  "UNTSO",
  "UNVMC",
  "VAC",
  "Victims’ Rights Advocate",
  "N/A"
]

export const sensitivityLevelList = ["PUBLIC", "UNCLASSIFIED", "CONFIDENTIAL", "STRICTLY CONFIDENTIAL"]

export const organizationList = ["United Nations"]

export const organizationIDList = ["UNS"]

export const entityMap = {'ACABQ': 'Secretariat to the Advisory Committee on Administrative and Budgetary Questions',
'CAAC': 'Special Representative of the Secretary-General for Children and Armed Conflict',
'CEB Secretariat': 'Secretariat for the United Nations System Chief Executives Board for Coordination',
'CTED': 'Counter-Terrorism Committee Executive Directorate',
'DESA': 'Department of Economic and Social Affairs',
'DGACM': 'Department for General Assembly and Conference Management',
'DGC': 'Department of Global Communications',
'DMSPC': 'Department of Management, Strategy, Policy and Compliance',
'DOS': 'Department of Operational Support',
'DPO': 'Department of Peace Operations',
'DPPA': 'Department of Political and Peacebuilding Affairs',
'DSS': 'Department of Safety and Security',
'ECA': 'Economic Commission for Africa',
'ECE': 'Economic Commission for Europe',
'ECLAC': 'Economic Commission for Latin America and the Caribbean',
'EOSG': 'Executive Office of the Secretary-General',
'ESCAP': 'Economic and Social Commission for Asia and the Pacific',
'ESCWA': 'Economic and Social Commission for Western Asia',
'Ethics Office': 'United Nations Ethics Office',
'ICSC': 'International Civil Service Commission',
'IIIM Syria': 'International, Impartial and Independent Mechanism (Syria)',
'JIU': 'Joint Inspection Unit of the United Nations System',
'MICT': 'United Nations International Residual Mechanism for Criminal Tribunals',
'MINUJUSTH': 'United Nations Mission for Justice Support in Haiti',
'MINURSO': 'United Nations Mission in Referendum in Western Sahara',
'MINUSCA': 'United Nations Multidimensional Integrated Stabilization Mission in the Central African Republic',
'MINUSMA': 'United Nations Multidimensional Integrrated Stabilization Mission in Mali',
'MONUSCO': 'United Nations Organization Stabilization Mission in the Democratic Republic of the Congo',
'OAJ': 'Office of Administration of Justice',
'OCHA': 'Office for the Coordination of Humanitarian Affairs',
'OCT': 'United Nations Office of Counter-Terrorism',
'ODA': 'Office for Disarmament Affairs',
'OHCHR': 'Office of the United Nations High Commissioner for Human Rights',
'OHRLLS': 'Office of the High Representative for the Least Developed Countries, Landlocked Developing Countries and Small Island Developing States',
'OIOS': 'Office of Internal Oversight Services',
'OLA': 'Office of Legal Affairs',
'OOSA': 'United Nations Office for Outer Space Affairs',
'OSAA': 'Office of the Special Adviser on Africa',
'OSASG Cyprus': 'Office of the Special Adviser to the Secretary-General on Cyprus',
'OSASG-PG': 'Office of the Special Adviser to the Secretary General on the Prevention of Genocide',
'OSE Great Lakes': 'Office of the Special Envoy of the Secretary-General for the Great Lakes',
'OSE Haiti': 'Office of the Special Envoy for Haiti',
'OSE Myanmar': 'Office of the Special Envoy for Myanmar',
'OSE Syria': 'Office of the Special Envoy for Syria',
'OSE Western Sahara': 'Office of the Special Envoy for Western Sahara',
'OSE Yemen': 'Office of the Special Envoy for Yemen',
'OSESG HoA': 'Office of the Special Envoy of the Secretary-General for the Horn of Africa',
'OSESG-1559': 'Office of the Special Envoy of the Secretary-General for the Implementation of Security Council Resolution 1559',
'OSESG-B': 'Office of the Special Envoy of the Secretary-General for Burundi',
'RCO Afghanistan': 'Resident Coordinator Office for Afghanistan',
'RCO Albania': 'Resident Coordinator Office for Albania',
'RCO Algeria': 'Resident Coordinator Office for Algeria',
'RCO Angola': 'Resident Coordinator Office for Angola',
'RCO Argentina': 'Resident Coordinator Office for Argentina',
'RCO Armenia': 'Resident Coordinator Office for Armenia',
'RCO Azerbaijan': 'Resident Coordinator Office for Azerbaijan',
'RCO Bahrain': 'Resident Coordinator Office for Bahrain',
'RCO Bangladesh': 'Resident Coordinator Office for Bangladesh',
'RCO Barbados': 'Resident Coordinator Office for Barbados',
'RCO Belarus': 'Resident Coordinator Office for Belarus',
'RCO Belize': 'Resident Coordinator Office for Belize',
'RCO Benin': 'Resident Coordinator Office for Benin',
'RCO Bhutan': 'Resident Coordinator Office for Bhutan',
'RCO Bolivia': 'Resident Coordinator Office for Bolivia',
'RCO Bosnia & Herzegovina': 'Resident Coordinator Office for Bosnia and Herzegovina',
'RCO Botswana': 'Resident Coordinator Office for Botswana',
'RCO Brazil': 'Resident Coordinator Office for Brazil',
'RCO Burkina Faso': 'Resident Coordinator Office for Burkina Faso',
'RCO Burundi': 'Resident Coordinator Office for Burundi',
'RCO Cambodia': 'Resident Coordinator Office for Cambodia',
'RCO Cameroon': 'Resident Coordinator Office for Cameroon',
'RCO Cape Verde': 'Resident Coordinator Office for Cape Verde',
'RCO Central African Republic': 'Resident Coordinator Office for Central African Republic',
'RCO Chad': 'Resident Coordinator Office for Chad',
'RCO Chile': 'Resident Coordinator Office for Chile',
'RCO China': 'Resident Coordinator Office for China',
'RCO Colombia': 'Resident Coordinator Office for Colombia',
'RCO Comoros': 'Resident Coordinator Office for Comoros',
'RCO Costa Rica': 'Resident Coordinator Office for Costa Rica',
"RCO Côte d'Ivoire": "Resident Coordinator Office for Côte d'Ivoire",
'RCO Cuba': 'Resident Coordinator Office for Cuba',
'RCO Dem Republic of Congo': 'Resident Coordinator Office for Democratic Republic of the Congo',
'RCO Djibouti': 'Resident Coordinator Office for Djibouti',
'RCO Dominican Republic': 'Resident Coordinator Office for Dominican Republic',
'RCO DPRK': 'Resident Coordinator Office for DPRK',
'RCO Ecuador': 'Resident Coordinator Office for Ecuador',
'RCO Egypt': 'Resident Coordinator Office for Egypt',
'RCO El Salvador': 'Resident Coordinator Office for El Salvador',
'RCO Equatorial Guinea': 'Resident Coordinator Office for Equatorial Guinea',
'RCO Eritrea': 'Resident Coordinator Office for Eritrea',
'RCO eSwatini': 'Resident Coordinator Office for eSwatini',
'RCO Ethiopia': 'Resident Coordinator Office for Ethiopia',
'RCO Fiji': 'Resident Coordinator Office for Fiji',
'RCO Gabon': 'Resident Coordinator Office for Gabon',
'RCO Gambia': 'Resident Coordinator Office for Gambia',
'RCO Georgia': 'Resident Coordinator Office for Georgia',
'RCO Ghana': 'Resident Coordinator Office for Ghana',
'RCO Guatemala': 'Resident Coordinator Office for Guatemala',
'RCO Guinea': 'Resident Coordinator Office for Guinea',
'RCO Guinea-Bissau': 'Resident Coordinator Office for Guinea-Bissau',
'RCO Guyana': 'Resident Coordinator Office for Guyana',
'RCO Haiti': 'Resident Coordinator Office for Haiti',
'RCO Honduras': 'Resident Coordinator Office for Honduras',
'RCO India': 'Resident Coordinator Office for India',
'RCO Indonesia': 'Resident Coordinator Office for Indonesia',
'RCO Iran': 'Resident Coordinator Office for Iran, Islamic Rep.',
'RCO Iraq': 'Resident Coordinator Office for Iraq',
'RCO Jamaica': 'Resident Coordinator Office for Jamaica',
'RCO Jordan': 'Resident Coordinator Office for Jordan',
'RCO Kazakhstan': 'Resident Coordinator Office for Kazakhstan',
'RCO Kenya': 'Resident Coordinator Office for Kenya',
'RCO Kosovo': 'Resident Coordinator Office for Kosovo',
'RCO Kuwait': 'Resident Coordinator Office for Kuwait',
'RCO Kyrgyzstan': 'Resident Coordinator Office for Kyrgyzstan',
'RCO Lao P.D.R': 'Resident Coordinator Office for Lao People’s Democratic Republic',
'RCO Lebanon': 'Resident Coordinator Office for Lebanon',
'RCO Lesotho': 'Resident Coordinator Office for Lesotho',
'RCO Liberia': 'Resident Coordinator Office for Liberia',
'RCO Libya': 'Resident Coordinator Office for Libya',
'RCO Madagascar': 'Resident Coordinator Office for Madagascar',
'RCO Malawi': 'Resident Coordinator Office for Malawi',
'RCO Malaysia': 'Resident Coordinator Office for Malaysia',
'RCO Maldives': 'Resident Coordinator Office for Maldives',
'RCO Mali': 'Resident Coordinator Office for Mali',
'RCO Mauritania': 'Resident Coordinator Office for Mauritania',
'RCO Mauritius': 'Resident Coordinator Office for Mauritius',
'RCO Mexico': 'Resident Coordinator Office for Mexico',
'RCO Moldova': 'Resident Coordinator Office for Moldova',
'RCO Mongolia': 'Resident Coordinator Office for Mongolia',
'RCO Montenegro': 'Resident Coordinator Office for Montenegro',
'RCO Morocco': 'Resident Coordinator Office for Morocco',
'RCO Myanmar': 'Resident Coordinator Office for Myanmar',
'RCO Namibia': 'Resident Coordinator Office for Namibia',
'RCO Nepal': 'Resident Coordinator Office for Nepal',
'RCO Niger': 'Resident Coordinator Office for Niger',
'RCO Nigeria': 'Resident Coordinator Office for Nigeria',
'RCO North Macedonia': 'Resident Coordinator Office for North Macedonia',
'RCO Pakistan': 'Resident Coordinator Office for Pakistan',
'RCO Palestine': 'Resident Coordinator Office for Palestine',
'RCO Panama': 'Resident Coordinator Office for Panama',
'RCO Papua New Guinea': 'Resident Coordinator Office for Papua New Guinea',
'RCO Paraguay': 'Resident Coordinator Office for Paraguay',
'RCO Peru': 'Resident Coordinator Office for Peru',
'RCO Philippines': 'Resident Coordinator Office for Philippines',
'RCO Republic of Congo': 'Resident Coordinator Office for Republic of Congo',
'RCO Rwanda': 'Resident Coordinator Office for Rwanda',
'RCO Samoa': 'Resident Coordinator Office for Samoa',
'RCO São Tomé & Principe': 'Resident Coordinator Office for São Tomé and Principe',
'RCO Saudi Arabia': 'Resident Coordinator Office for Saudi Arabia',
'RCO Senegal': 'Resident Coordinator Office for Senegal',
'RCO Serbia': 'Resident Coordinator Office for Serbia',
'RCO Sierra Leone': 'Resident Coordinator Office for Sierra Leone',
'RCO Somalia': 'Resident Coordinator Office for Somalia',
'RCO South Africa': 'Resident Coordinator Office for South Africa',
'RCO South Sudan': 'Resident Coordinator Office for South Sudan',
'RCO Sri Lanka': 'Resident Coordinator Office for Sri Lanka',
'RCO Sudan': 'Resident Coordinator Office for Sudan',
'RCO Suriname': 'Resident Coordinator Office for Suriname',
'RCO Syria': 'Resident Coordinator Office for Syrian Arab Republic',
'RCO Tajikistan': 'Resident Coordinator Office for Tajikistan',
'RCO Tanzania': 'Resident Coordinator Office for United Republic of Tanzania',
'RCO Thailand': 'Resident Coordinator Office for Thailand',
'RCO Timor-Leste': 'Resident Coordinator Office for Timor-Leste',
'RCO Togo': 'Resident Coordinator Office for Togo',
'RCO Trinidad & Tobago': 'Resident Coordinator Office for Trinidad & Tobago',
'RCO Tunisia': 'Resident Coordinator Office for Tunisia',
'RCO Turkey': 'Resident Coordinator Office for Turkey',
'RCO Turkmenistan': 'Resident Coordinator Office for Turkmenistan',
'RCO U.A Emirates': 'Resident Coordinator Office for U.A Emirates',
'RCO Uganda': 'Resident Coordinator Office for Uganda',
'RCO Ukraine': 'Resident Coordinator Office for Ukraine',
'RCO Uruguay': 'Resident Coordinator Office for Uruguay',
'RCO Uzbekistan': 'Resident Coordinator Office for Uzbekistan',
'RCO Venezuela': 'Resident Coordinator Office for Venezuela, RB',
'RCO Vietnam': 'Resident Coordinator Office for Vietnam',
'RCO Yemen': 'Resident Coordinator Office for Yemen, Rep.',
'RCO Zambia': 'Resident Coordinator Office for Zambia',
'RCO Zimbabwe': 'Resident Coordinator Office for Zimbabwe',
'RSEA': 'United Nations Response to Sexual Exploitation and Abuse',
'SVC': 'Special Representative of the Secretary-General on Sexual Violence in Conflict',
'UNAMA': 'United Nations Assistance Mission in Afghanistan',
'UNAMI': 'United Nations Assistance Mission in Iraq',
'UNAMID': 'United Nations - African Union Hybrid Operation in Darfur',
'UNCTAD': 'United Nations Conference on Trade and Development',
'UNDCO': 'United Nations Development Coordination Office',
'UNDOF': 'United Nations Disengagement Observer Force',
'UNDRR': 'United Nations Office for Disaster Risk Reduction',
'UNEP': 'United Nations Environment Programme',
'UNFICYP': 'United Nations Peacekeeping Force in Cyprus',
'UNGC': 'United Nations Global Compact',
'UN-Habitat': 'United Nations Human Settlements Programme',
'UNIDIR': 'United Nations Institute for Disarmament Research',
'UNIFIL': 'United Nations Interim Force in Lebanon',
'UNIOGBIS': 'United Nations Ingrated Peacebuilding Office in Guinea-Bissau',
'UNISFA': 'United Nations Interim Security Force for Abyei',
'UNITAD': "United Nations Investigations Team for Accountability of Da'esh/ISIL",
'UNJSPF-CEO': 'United Nations Joint Staff Pension Fund - Secretariat',
'UNJSPF-RSG': 'United Nations Joint Staff Pension Fund - Office of Investment Management',
'UNMHA': 'United Nations Mission in Support of the Hodeidah Agreement',
'UNMIK': 'United Nations Mission in Kosovo',
'UNMISS': 'United Nations Mission in South Sudan',
'UNMOGIP': 'United Nations Military Oberver Group in India and Pakistan',
'UNOAU': 'United Nations Office to the African Union',
'UNOCA': 'United Nations Regional Office for Central Africa',
'UNODC': 'United Nations Office on Drugs and Crime',
'UNOG': 'United Nations Office at Geneva',
'UNOMS': 'United Nations Office for Ombudsman and Mediation Services',
'UNON': 'United Nations Office at Nairobi',
'UNOP': 'United Nations Office for Partnerships',
'UNOV': 'United Nations Office at Vienna',
'UNOWAS': 'United Nations Office for West Africa and the Sahel',
'UNRCCA': 'United Nations Regional Centre for Preventative Diplomacy for Central Asia',
'UNRGID': 'United Nations Representative to Geneva International Discussions',
'UNRoD': 'United Nations Register of Damage Caused by the Construction of the Wall in the OPT',
'UNSCO': 'United Nations Special Coordinator for the Middle East Peace Process',
'UNSCOL': 'Office of the United Nations Special Coordinator for Lebanon',
'UNSMIL': 'United Nations Support Mission in Libya',
'UNSOM': 'United Nations Assistance Mission in Somalia',
'UNSOS': 'United Nations Support Office in Somalia',
'UNTFHS': 'United Nations Trust Fund for Human Security',
'UNTSO': 'United Nations Truce Supervision Organization',
'UNVMC': 'United Nations Verification Mission in Colombia',
'VAC': 'Special Representative of the Secretary-General on Violence Against Children',
'Victims’ Rights Advocate': "Office of the Victims' Rights Advocate",
'N/A':"Not Applicable"}

export const functionList = ["ACC",
"ADM",
"BUF",
"CIV",
"CDU",
"COM",
"CON",
"DDR",
"DEV",
"DRA",
"EAO",
"ELE",
"ENV",
"GEN",
"GOV",
"HIV",
"HRM",
"HRT",
"HUM",
"ICT_O",
"ICT_S",
"INM",
"JPC",
"LAE",
"LEG",
"MGT",
"MIL",
"MIN",
"MOV",
"OPS",
"OSF",
"OVE",
"PM",
"POL",
"PPE",
"PUB",
"REA",
"SCM",
"SOSF",
"SSM",
"SSR",
"SU",
"SUB ",
"SWE",
"UPA",
"N/A"]

export const functionMap = {'ACC': 'Does ongoing analysis of enterprise data to enable continuous learning and improvement; enterprise-level guidance implementation of results-based management and proactive risk management. At HQ, sits in the Department of Management Strategy, Policy and Compliance (DMSPC), Business Transformation and Accountability office, and others.',
'ADM': 'Covers all admin functions of the Organization, including assets, business continuity, non-record contract management, procurement, and facilities management. Cross-organizational. For Executive Offices with permanent records, see function EAO.',
'BUF': 'Regular budget management and reporting, support account management and reporting, extra budgetary resources management and reporting. Cross-organizational.',
'CIV': 'Network of peacekeeping staff operating to provide conflict management support within the broader context of a mission\'s "protection of civilians" responsibilities, to facilitate a countrywide implementation of peacekeeping mandates and to support the population and government in strengthening conditions and structures conducive to sustainable peace. Found in DPPA/DPO and field missions.',
'CDU': 'Covers the work produced by offices related to preventing misconduct, handling complaints and  ensuring compliance with United Nations standards of conduct. Cross-organizational, including Conduct and Discipline entities in field missions and Ombudsman and mediation services in headquarters and regional offices.',
'COM': 'The dissemination of global UN messages to local audiences. This function serves as a reliable source of up-to-date information about the UN, delivering information to a wide range of people, including journalists, government officials, civil society representatives, students, educators and researchers. Cross-entity.',
'CON': 'Substantive conference management for headquarters, regional offices and field missions. Includes providing the physical and deliberative framework for  intergovernmental meetings, including technical secretariat support and advice to intergovernmental bodies, meetings management and documentation management. Cross-organizational. Not all conference management need to use this - for similar, non-substantive functions, see ADM.',
'DDR': 'Function that provides mediation support: deployment of experts, drafting provision of agreements, and negotiation advice; analysis: mapping of armed groups and identification of entry points for programmatic engagement; capacity building: strengthening the parties’ ability to work constructively towards an agreement. Commonly found in peacekeeping and the Office of Disarmament Affairs.',
'DEV': 'Includes topics relating to intergovernmental support, SGD knowledge, population dynamics, public institutions, sustainable financing, economic analysis, social inclusion, statistics, forests. Mainly found in DESA, UNCTAD, and regional commissions; cross-entity.',
'DRA': 'Understanding the risk and risk impact of disasters (where natural hazards negatively meet people), convening and coordinating risk reduction activities. Cross-organizational and cross-entity.',
'EAO': 'The EO assists the USG with functions such as personnel, finance and general administration. Its substantive responsibilities may include strategic staffing table management, policy guidance with regards to HR matters, and appointments management. Cross-organizational. Not all EOs need to use this - for similar, non-permanent functions, see ADM.',
'ELE': 'Electoral assistance entails providing technical advice and other assistance to requesting States and electoral institutions in order to help to strengthen their democratic processes, including in the form of mediation and good offices. Most commonly found in DPPA/DPO and field missions.',
'ENV': 'Work that promotes environmental sustainability while contributing to a balanced integration of the economic, social and environmental dimensions of sustainable development. Includes climate change, resilience to disasters and conflicts, healthy and productive ecosystems, environmental governance, chemicals waste and air quality and resource efficiency. Cross-entity, mostly focused in UNEP.',
'GEN': 'Work that provides advice and support to the Organization and mission’s leadership on ways to promote women’s political participation, make peace processes and prevention efforts more inclusive, and include a gender perspective in the UN’s political work. Mostly found in field missions, but cross-organizational.',
'GOV': 'Governance is the systems and processes that ensure the overall effectiveness of an entity - it includes policy, compliance, guidelines related to the Organization-specific function and the work of senior officials. Cross-organizational. See MGT for the day-to-day management of specific offices or sections.',
'HIV': 'Work that relates to HIV and AIDS. Cross-entity.',
'HRM': 'Staffing and recruitment, staff administration, performance management, attendance and leave, travel administration, non-record pension information. Cross-organizational.',
'HRT': 'Related to the promotion of rights inherent to all human beings, regardless of status within specific demographics. Encompasses work relating to economic, social, cultural, civil and political rights. Cross-entity.',
'HUM': 'Work related to the administration and coordination of humanitarian activities, including the provision of assistance to victims of war, pandemics/epidemics and natural disasters. Cross-entity, but most commonly found in DPPA and field missions.',
'ICT_O': 'Operational work related to enterprise applications, new technology and innovation, global and local ICT infrastructure, information security and ICT architecture. Cross-organizational.',
'ICT_S': 'Policy and governance related to enterprise applications, new technology and innovation, global and local ICT infrastructure, information security, ICT project management, architecture and standards. Cross-organizational.',
'INM': 'Work relating to the management of information, records, archives, data and knowledge. Cross-organizational.',
'JPC': 'Related to the restoration of and support to justice, prison and corrections institutions and strengthening the rule of law. Found in field missions, cross-organizational and cross-entity.',
'LAE': 'Related to the provision of law enforcement and related activities in peacekeeping missions, rotation of formed police units. Most commonly found in DPPA/DPO and field missions.',
'LEG': 'Work related to providing a unified central legal service for the Secretariat and the principal and other organs of the United Nations, to contribute to the progressive development and codification of international public and trade law, to promote the strengthening and development as well as the effective implementation of the international legal order for the seas and oceans, to register and publish treaties, and to perform the depositary functions of the Secretary-General. Cross-organizational.',
'MGT': 'Covers the day-to-day management, coordination, policies and planning of individual offices within the Organization when the substantive work is not covered by a specific function code. See also: GOV for strategic and Organizational planning and the work of senior officials.',
'MIL': 'Covers provision and management of military and related activities in peacekeeping missions; rotation of military contingents; military-civil coordination. Common to DPPA/DPO and field missions.',
'MIN': 'Work to mitigate the threats posed by mines, explosive remnants of war and improvised explosive devices. Commonly found under UNMAS in DPO.',
'MOV': 'Relating to movement of equipment, military contingents, and formed police units within and to/from peacekeeping missions and to the movement of all personnel and equipment inside a mission area. Common to DPPA/DPO and field missions.',
'OPS': 'Covers all operational work of the United Nations not included in individual function codes. Cross-organizational.',
'OSF': "Official personnel file for UN staff including  information relating to staff's employment; also covers files concerning the medical status and condition of each staff member, including illnesses, physical examinations, and treatments. For senior officials, see SOSF.  Cross-organizational.",
'OVE': 'Reviews  administrative and substantive work. Activities include Board of Auditors and Board of Inquiry case work, OIOS investigations, Joint Inspection Units, and internal and external auditing. Cross-organizational.',
'PM': 'Project management oversight, governance, standardization, methodology, best practices, training, tools and templates. Cross-organizational.',
'POL': 'Work that deals with the dynamics of armed conflict, including activities to help resolve them through peaceful processes, such as negotiation processes and good offices. Common to DPPA/DPO and field missions.',
'PPE': 'Related to engagement with entities and the public. Cross-organizational, but commonly found in DGC.',
'PUB': "Covers the strategy, creation, management, and dissemination of materials that document, describe, and promote the Organization's work. Cross-organizational, but commonly found in DGC. For the dissemination of public information, see COM.",
'REA': 'Aggregating, harvesting, collecting, analyzing and interpreting data, information and knowledge to increase the understanding of a topic, and support decision-making. Cross organizational.',
'SCM': 'Work relating to supply chain planning and performance management, logistical support, procurement, vendor management and supplier diversity, and uniformed capabilities support. Commonly found in DOS and field missions.',
'SOSF': "Official personnel file for UN staff at the ASG level and above including  information relating to staff's employment. For staff below the ASG level, see OSF.",
'SSM': 'Related to safety and security programmes and practices, including physical, personnel and travel safety and security; investigations of safety and security incidents. Cross-organizational, including field missions.',
'SSR': 'Related to security sector development, including assessment, review and reform of the security sector and its institutions. Most commonly found in DPPA/DPO and field missions.',
'SU': 'Covers all information created by staff unions.',
'SUB': 'Covers all substantive work of the United Nations not included in individual function codes.',
'SWE': 'Encompass staff health, associations, engagement, communications and promoting a safe and healthy work environment.',
'UPA': 'Relating to generation, rotation, replacement and repatriation of contingents in mission areas. Found in field missions.',
'N/A': 'Not applicable.'}

export const frequencyList = ["DAILY",
  "WEEKLY",
  "MONTHLY",
  "QUARTERLY",
  "SEMI-ANNUALLY",
  "ANNUALLY",
  "IRREGULARLY"]

export const languageList = [
  "ARABIC",
"CHINESE",
"ENGLISH",
"FRENCH",
"RUSSIAN",
"SPANISH"
]



export const organizationMap = {
  "United Nations":"UNS"
};

export const userGuidMap = {
  "4dc18349-286c-4883-b8e6-0428500294d9":{
    "name":"DOS Travel Business Analytics Team",
    "email":"dos-travel-analytics@un.org"
  },
  "ed897c2f-6acb-41c8-8522-cc84725d77a6":{
    "name":"DOS-Travel",
    "email":"dos-travel@un.org"
  },
  "db47e237-84cd-4175-bfc3-94719194f454":{
    "name":"ADM Eric Cai",
    "email":"adm.ccai4@global.un.org"
  },
  "e3cde6cf-be9e-4a4b-99a9-be565a2d34f3":{
    "name":"Azure Service Principal",
    "email":""
  },
  "57baf09b-c43c-4673-895d-5a051de42a6a":{
    "name":"Sudhindra Swamy",
    "email":"swamy@un.org"
  },
  "a46e705b-552b-4b11-85da-f8cb0354ff2c":{
    "name":"Director, Population Division",
    "email":"population@un.org"
  }
};

export const restrictedEntities = [];

export const environmentSelection = "production"
// export const environmentSelection = "development"

export const environmentSetUp = {
  "purviewAccessToken":{
    // "development":"https://data-catalog-token-server-dev-v2.azurewebsites.net/api/getToken",
    "development":"https://data-catalog-token-server-dev.azurewebsites.net/api/getToken",
    "production":"https://data-catalog-token-server.azurewebsites.net/api/getToken"
  },
  "searchSuggestUrl":{
    "development":"https://sys-purview.catalog.purview.azure.com/api/atlas/v2/search/suggest",
    "production":"https://sys-purview-prod.catalog.purview.azure.com/api/atlas/v2/search/suggest"
  },
  "advancedSearchUrl":{
    "development":"https://sys-purview.purview.azure.com/catalog/api/search/query?api-version=2022-03-01-preview",
    //"production":"https://sys-purview-prod.purview.azure.com/catalog/api/search/query?api-version=2022-03-01-preview"
    //"development":"https://sys-purview.catalog.purview.azure.com/api/atlas/v2/search/advanced",
    "production":"https://sys-purview-prod.catalog.purview.azure.com/api/atlas/v2/search/advanced"
  },
  "detailBaseUrl":{
    "development":"https://sys-purview.catalog.purview.azure.com/api/atlas/v2/entity/guid/",
    "production":"https://sys-purview-prod.catalog.purview.azure.com/api/atlas/v2/entity/guid/"
  },
  "addGlossaryTermsBaseUrl":{
    "development":"https://sys-purview.catalog.purview.azure.com/api/atlas/v2/glossary/terms/",
    "production":"https://sys-purview-prod.catalog.purview.azure.com/api/atlas/v2/glossary/terms/"
  },
  "deleteGlossaryTermsBaseUrl":{
    "development":"https://sys-purview.catalog.purview.azure.com/api/atlas/v2/glossary/terms/",
    "production":"https://sys-purview-prod.catalog.purview.azure.com/api/atlas/v2/glossary/terms/"
  },
  "deleteEntityBaseUrl":{
    "development":"https://sys-purview.catalog.purview.azure.com/api/atlas/v2/entity/guid/",
    "production":"https://sys-purview-prod.catalog.purview.azure.com/api/atlas/v2/entity/guid/"
  },
  "saveChangesBaseUrl":{
    "development":"https://sys-purview.catalog.purview.azure.com/api/atlas/v2/entity",
    "production":"https://sys-purview-prod.catalog.purview.azure.com/api/atlas/v2/entity"
  },
  "readGlossaryUrl":{
    "development":"https://sys-purview.catalog.purview.azure.com/api/atlas/v2/glossary/49305c01-7a53-4bbb-9def-21e9bd8e1c5c/terms",
    "production":"https://sys-purview-prod.catalog.purview.azure.com/api/atlas/v2/glossary/8e441120-c35f-4138-ba34-a28b3825b609/terms"
  },
  "editEntityDataUrl":{
    "development":"https://web.purview.azure.com/resource/sys-purview/main/catalog/entity/edit?guid={{guid}}&feature.tenant="+tenant,
    "production":"https://web.purview.azure.com/resource/sys-purview-prod/main/catalog/entity/edit?guid={{guid}}&feature.tenant="+tenant
  }
}

